import React, { useEffect, useState } from "react";
import { authenticate } from "../lib/serverComm";

interface LoginProps {
  onAuthenticated: () => void;
}

let authenticating = false;
const Login: React.FC<LoginProps> = ({ onAuthenticated }) => {
  //const [authenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const tryauth = async () => {
      localStorage.removeItem("authToken");
      setError("");
      // get auth_nonce from query parameter
      const searchParams = new URLSearchParams(window.location.search);
      const auth_nonce = searchParams.get("auth_nonce");
      if (auth_nonce && !authenticating) {
        try {
          authenticating = true;
          await authenticate(auth_nonce);
          onAuthenticated();
        } catch (err) {
          setError(
            err instanceof Error ? err.message : "Authentication failed",
          );
        }
      } else if (!auth_nonce) {
        setError("auth_nonce not set in query parameter");
      }
    };
    tryauth();
  }, [onAuthenticated]);

  return <>{error && <p className="text-red-500 mt-2">{error}</p>}</>;
};

export default Login;
